// en/channel.js
export const channel = {
  header: {
    title: "Booking channels",
    subtitle: "Sync or manage Booking.com, Expedia, Airbnb and many more.",
  },

  establishedConnections: "Established connections",

  common: {
    loading: "Loading...",
    configure: "Configure",
    close: "Close",
    comingSoon: "Coming soon",
  },

  alerts: {
    bullets: {
      choosePlan: "Choose a plan and activate your Channel Manager.",
      completeProperty: "Complete your property setup in the dashboard.",
    },
    title: "Action required",
    planRequired:
      "You must have an active plan to link your property with an OTA.",
    missingPropertyChannel:
      "To connect with an OTA you need to complete your property setup in the Channel Manager first.",
  },

  modal: {
    channelHeader: "Channel connection with {channel}",
  },

  web: {
    cardTitle: "Direct web bookings",
    // NEW: description for the OTA-style card
    cardDescription:
      "Receive direct bookings from your website without OTA commissions.",
    // NEW: button texts for card and table
    manageCta: "Manage",
    configureCta: "Configure",
    // NEW: label for the ID column of the direct bookings row
    directLinkLabel: "Direct booking link",

    linkShareMessage: "Hi there 👋 You can book using this link:\n\n{link}",
    modalTitle: "Direct web bookings",
    description:
      "Enable or disable the options available for direct booking on your website. Guests will be able to book directly without intermediaries.",
    toggleAllDesktop: "Enable/Disable all web bookings",
    toggleAllMobile: "Enable/Disable",
    table: {
      name: "Name",
      available: "Available for web booking",
    },
    capacity: "Capacity",
    people: "people",
    empty: "No items found",

    // Link section
    linkTitle: "Your direct booking link",
    linkHelp: "Share this link so your guests can book directly",
    linkCopyTooltip: "Copy link",
    linkShareWhatsappTooltip: "Share on WhatsApp",
  },

  plan: {
    title: "Activate your plan to connect",
    subtitle:
      "Choose the plan that fits your needs and enable the connection with Booking, Airbnb, Expedia and more.",
    hint: "Once you subscribe, come back here; we’ll unlock all the channels you can connect to.",
    cta: "Upgrade plan",
  },

  toasts: {
    paymentTypeUpdated: "Payment method updated successfully",
    linkCopiedTitle: "Copied!",
    linkCopiedBody: "Link copied successfully",
    linkCopyErrorTitle: "Error",
    linkCopyErrorBody: "There was an error copying the link",
    save: "Error saving configuration",
    updateWebReservation: "Error updating web reservation",
    saved: "Configuration saved successfully",
    updateWebReservationsGlobal:
      "Global state of direct bookings updated successfully",
  },

  errors: {
    loadData: "Error loading data. Please try again.",
    generateToken: "Error generating token",
    connectChannel: "Error connecting to the channel. Please try again.",
    updatePaymentType: "Error updating payment method",
    save: "Error saving configuration",
    updateWebReservation: "Error updating web reservation",
  },

  tabs: {
    reservations: "Booking status",
    payments: "Prices & Payments",
    share: "Share",
  },

  payments: {
    title: "How would you like to receive direct booking payments?",
    onArrival: {
      label: "Pay at the property",
      desc: "Guests will pay directly upon arrival",
    },
    online: {
      label: "Online prepayment",
      desc: "Guests will pay when making the booking",
    },
  },

  discounts: {
    sectionTitle: "Configure discount for direct bookings",
    toggle: "Apply discount to direct bookings",
    typeTitle: "Discount type:",
    percentage: {
      label: "Percentage discount",
      desc: "Apply a percentage discount",
    },
    fixed: {
      label: "Fixed price discount",
      desc: "Apply a fixed amount discount",
    },
    valueTitle: "Discount value:",
    placeholderPercentage: "Ex: 10",
    placeholderFixed: "Ex: 50.00",
    helpPercentage:
      "Enter a value between 1 and 100 for the discount percentage",
    helpFixed: "Enter the fixed amount in euros to be deducted from the total",
    previewTitle: "Preview:",
    previewPercentage: "A {value}% discount will be applied to direct bookings",
    previewFixed: "A €{value} discount will be applied to direct bookings",
  },

  buttons: {
    saveChanges: "Save changes",
  },
};
